import { render, staticRenderFns } from "./ParameterQuestionComponent.vue?vue&type=template&id=28907f54"
import script from "./ParameterQuestionComponent.vue?vue&type=script&lang=ts"
export * from "./ParameterQuestionComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports